import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import orderBy from 'lodash/orderBy';
import React from 'react';
import Helmet from 'react-helmet';
import { FormattedMessage, defineMessages } from 'react-intl';
import Layout from 'components/Layout';
import Countries from 'constants/Countries.json';
import countries from 'constants/SupportedCountries.json';
import '../styles/select-country.scss';
const messages = defineMessages({
    title: 'Select your country:',
});
export default class SelectCountry extends React.Component {
    constructor() {
        super(...arguments);
        this.renderCountry = (country, index) => {
            return (_jsx("li", { children: _jsxs("a", { href: `/?country=${country.code}`, children: [_jsx("span", { className: `flag-icon flag-icon-${country.code}` }), " ", country.name] }) }, index));
        };
    }
    render() {
        const countryModels = orderBy(countries.map((c) => ({
            code: c.country,
            name: Countries[c.country] ? Countries[c.country].name : c.name,
            supported: !c.unsupported,
        })), ['supported', 'name'], ['desc', 'asc']);
        return (_jsxs(Layout, { className: "select-country", children: [_jsx(Helmet, { meta: [{ name: 'event-id', content: 'select-your-country' }] }), _jsxs(Layout.Container, { children: [_jsx("h2", { children: _jsx(FormattedMessage, Object.assign({}, messages.title)) }), _jsx("ul", { className: "select-country__list", children: countryModels.map(this.renderCountry) })] })] }));
    }
}
